// https://developers.line.biz/ja/reference/messaging-api/#text-message
// 最大文字数：5000
// LINE絵文字は絵文字ごとに文字サイズカウント数が異なるため、余分をもって上限を3000にする
export const MAX_TEXTMESASAGE_LENGTH = 3000;

// https://developers.line.biz/ja/reference/messaging-api/#text-message
// emojis 最大個数：20
export const MAX_EMOJIS_LENGTH_IN_TEXTMESSAGE = 20;